import "../SCSS/styles.css";
import QuestionsMobileView from "../Components/QuestionsMobileView";
import { useEffect, useRef, useState } from "react";
import { containerProps } from "../QuestionsMobileViewPropsTypes";
import images from "../../ImageVariables";
import ConfirmAlertHome from "../../Common/CommonComponent/ConfirmAlert/Component/ConfirmAlertHome";
import { Notify } from "../../Common/Notify/NotificationMessages";
import { NotificationManager } from "react-notifications";

function QuestionsMobileViewContainer({
  setCurrentPage,
  reducerState,
  questionObjVariable,
  oldOption,
  checkNestedDependency,
  dependencyAnsHash,
  dispatch,
  isPreview,
  mainRefObject,
  setDependencyAnsHash,
  surveyAnswers,
  setSurveyAnswers,
  surveyAnswersInfo,
  handleChangeAddComment,
  confirmDeleteFile,
  handleClearAnswer,
  clearValuesFromSurveyAnswers,
  SaveAsDraft,
  handleSubmitAnswers,
  removeAttachedFile,
  handleNoteComment,
}: containerProps) {
  const [viewAll, setViewAll] = useState<boolean>(false);
  const [allQuestions, setAllQuestions] = useState<boolean>(false);
  let [currentQuestion, setCurrentQuestion] = useState<number>(0);
  const disableButton = useRef<any>(null);
  const handleViewAllQuestions = () => {
    setViewAll(true);
  };
  const handleAllQuestions = () => {
    setAllQuestions(!allQuestions);
    setViewAll(false);
  };
  // back button
  const handleChangeBackButton = () => {
    if (allQuestions) {
      setAllQuestions(!allQuestions);
      //to get three dots
      setViewAll(false);
    } else {
      // we know it should always come to notes page
      setCurrentPage(2);
      sessionStorage.removeItem("currentQuestion");
      sessionStorage.removeItem("currentPage");
    }
  };
  //handle submit answers alert
  const confirmSubmitAnswer = () => {
    const mandatoryIdIndex: number[] = [];
    reducerState?.questionIdsToRender?.forEach(
      (questionId: string, i: number) => {
        if (
          (questionObjVariable[questionId].validation.mandatory.isMandatory &&
            !surveyAnswers[questionId]?.val &&
            surveyAnswers[questionId]?.val !== 0) ||
          (questionObjVariable[questionId].questionType === "checkbox" &&
            questionObjVariable[questionId].validation.mandatory.isMandatory &&
            surveyAnswers[questionId]?.isOthersChecked &&
            !surveyAnswers[questionId].val[
              questionObjVariable?.[questionId]?.optionInfo?.optionObj[
                questionObjVariable?.[questionId]?.optionInfo?.optionOrder[
                  questionObjVariable?.[questionId]?.optionInfo?.optionOrder
                    .length - 1
                ]
              ].optionId
            ].othersAnswer)
        ) {
          mandatoryIdIndex.push(i + 1);
        }
      }
    );
    const IdsIndex: number[] = [];
    reducerState?.questionIdsToRender?.forEach(
      (questionId: string, i: number) => {
        if (
          (!questionObjVariable[questionId].validation.mandatory.isMandatory &&
            !surveyAnswers[questionId]?.val &&
            surveyAnswers[questionId]?.val !== 0) ||
          (questionObjVariable[questionId].questionType === "checkbox" &&
            !questionObjVariable[questionId].validation.mandatory.isMandatory &&
            surveyAnswers[questionId]?.isOthersChecked &&
            !surveyAnswers[questionId].val[
              questionObjVariable?.[questionId]?.optionInfo?.optionObj[
                questionObjVariable?.[questionId]?.optionInfo?.optionOrder[
                  questionObjVariable?.[questionId]?.optionInfo?.optionOrder
                    .length - 1
                ]
              ].optionId
            ].othersAnswer)
        ) {
          IdsIndex.push(i + 1);
        }
      }
    );

    const confirmParameters = {
      title: {
        images: images.deleteAlert,
        titleName: "Some questions are not answered.",
      },

      descriptions: {
        first:
          mandatoryIdIndex?.length > 0
            ? `* Mandatory  ${
                mandatoryIdIndex.length === 1 ? "question" : "questions"
              } ${[...mandatoryIdIndex]} 
              ${mandatoryIdIndex.length === 1 ? "is" : "are"} not answered  `
            : "",

        second:
          IdsIndex?.length > 0
            ? `*  Question number ${[...IdsIndex]}  ${
                IdsIndex.length === 1 ? "is" : "are"
              } not answered.`
            : "",
        third: "",
      },

      note: Notify?.SUBMIT_MSG(surveyAnswersInfo?.companyInfo?.scmName),
      buttons: {
        Yes: "Submit",
        No: "Cancel",
      },
      //onclick must work only when there is a no mandatory questions else throw error
      onClick: () => {
        !mandatoryIdIndex.length
          ? handleSubmitAnswers()
          : NotificationManager.warning(Notify.MANDATORY_QSTN_WARN, "", 2000);
      },
      buttonClassName: {
        yes: "button-submit-ok",
        no: "button-confirm-cancel",
      },
      enableOnClose: !mandatoryIdIndex.length && true,
      enableDescription: mandatoryIdIndex.length > 0 || IdsIndex.length > 0,
      isMobile: true,
    };
    return ConfirmAlertHome({ confirmParameters });
  };

  const handlePrevAndNextQuestion = async (type: string) => {
    if (type === "prev") {
      setCurrentQuestion(currentQuestion - 1);
      sessionStorage.setItem(
        "currentQuestion",
        (currentQuestion - 1).toString()
      );
    } else {
      if (currentQuestion === reducerState?.questionIdsToRender?.length - 1) {
        confirmSubmitAnswer();
      } else {
        disableButton.current.style.pointerEvents = "none";

        await SaveAsDraft();
        setCurrentQuestion(currentQuestion + 1);
        disableButton.current.style.pointerEvents = "auto";

        sessionStorage.setItem(
          "currentQuestion",
          (currentQuestion + 1).toString()
        );
      }
    }
    // reducerState.isEdit = false;
  };
  const handleQuestionsToRender = (index: number) => {
    setCurrentQuestion(index);
    // to tell the component don't show all questions comp
    setAllQuestions(false);
    // set the current question in local storage, for handling refresh
    sessionStorage.setItem("currentQuestion", index.toString());
  };
  //click outside function
  let useClickOutside = (handler: any) => {
    let outsideClickRef: any = useRef();
    useEffect(() => {
      let eventHandler = (event: any) => {
        if (
          outsideClickRef.current &&
          !outsideClickRef.current.contains(event.target)
        )
          handler();
      };
      document.addEventListener("mousedown", eventHandler);
      return () => {
        document.removeEventListener("mousedown", eventHandler);
      };
    });
    return outsideClickRef;
  };
  const outsideClickRef = useClickOutside(() => {
    setViewAll(false);
  });
  // on refresh of page get current ques deatils from browser storage if it exists
  useEffect(() => {
    let currentQuestionFromStorage = sessionStorage.getItem("currentQuestion");
    currentQuestionFromStorage &&
      setCurrentQuestion(Number(currentQuestionFromStorage));
  }, []);
  // Remove a attachment from add attachment modal

  return (
    <QuestionsMobileView
      handleViewAllQuestions={handleViewAllQuestions}
      viewAll={viewAll}
      handleAllQuestions={handleAllQuestions}
      allQuestions={allQuestions}
      handleChangeBackButton={handleChangeBackButton}
      reducerState={reducerState}
      questionObjVariable={questionObjVariable}
      handlePrevAndNextQuestion={handlePrevAndNextQuestion}
      currentQuestion={currentQuestion}
      oldOption={oldOption}
      checkNestedDependency={checkNestedDependency}
      dependencyAnsHash={dependencyAnsHash}
      dispatch={dispatch}
      isPreview={isPreview}
      mainRefObject={mainRefObject}
      setDependencyAnsHash={setDependencyAnsHash}
      surveyAnswers={surveyAnswers}
      setSurveyAnswers={setSurveyAnswers}
      surveyAnswersInfo={surveyAnswersInfo}
      handleChangeAddComment={handleChangeAddComment}
      confirmDeleteFile={confirmDeleteFile}
      handleClearAnswer={handleClearAnswer}
      clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
      handleQuestionsToRender={handleQuestionsToRender}
      outsideClickRef={outsideClickRef}
      disableButton={disableButton}
      removeAttachedFile={removeAttachedFile}
      handleNoteComment={handleNoteComment}
    />
  );
}

export default QuestionsMobileViewContainer;
